require("normalize.css/normalize.css")
require("../css/ui.css")
require("./page.css")

document.addEventListener("DOMContentLoaded", () => {
  console.log("DOMContentLoaded", "Vertical2")
})
